import { Base } from "ui/Scripts/source/framework/base";
import { ISavedListFilter, SavedListFilter } from "./savedListFilter";

export interface IListFilterItem extends ISavedListFilter {
    isShared: boolean;
    isUserFilter: boolean;

    getHash(): string;
    getIsShared(): boolean;
    getIsUserLevel(): boolean;
}

export class ListFilterItem extends SavedListFilter implements IListFilterItem {
    isShared: boolean;
    isUserFilter: boolean;

    constructor();
    constructor(obj: IListFilterItem);
    constructor(obj: ISavedListFilter);
    constructor(obj?: any) {
        super(obj);
        this.isShared = obj && obj.isShared || false;
        this.isUserFilter = obj && obj.isUserFilter || false;
    }

    getHash(): string {
        return super.getHash() + "#" + this.isShared.toString() + "#" + this.isUserFilter.toString();
    }
    
    getIsShared(): boolean {
        return this.isShared;
    }

    getIsUserLevel(): boolean {
        return this.isUserFilter;
    }

    static getHash(items: IListFilterItem[]): string {
        if (!items && items.length < 1) return "";
        return items.map(i => i.getHash()).join(",");
    }

    static createListFilterItem(id: string, title: string, generalFilter: any, sortColumn: string, sortOrderIsAsc: boolean, sortOrder: number = 0): IListFilterItem {
        const result = new ListFilterItem();
        result.id = id;
        result.title = title;
        result.generalFilter = generalFilter;
        result.sortOrder = sortOrder;
        result.sortColumn = sortColumn;
        result.sortOrderIsAsc = sortOrderIsAsc;
        return result;
    }

    static createListFilterItemFromSavedListFilter(savedListFilter: ISavedListFilter, isShared: boolean): IListFilterItem {
        const result = new ListFilterItem(savedListFilter);
        result.isShared = isShared;
        result.isUserFilter = true;
        return result;
    }

    static sortListFilterItems(items: IListFilterItem[]): IListFilterItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IListFilterItem, b: IListFilterItem) => {
            if (!a || !b) return 0;
            let result = Base.numCompare(a.isUserFilter ? 0 : 1, b.isUserFilter ? 0 : 1);
            if (result !== 0) return result;
            result = Base.numCompare(a.isShared ? 1 : 0, b.isShared ? 1 : 0);
            if (result !== 0) return result;
            result = Base.numCompare(a.sortOrder, b.sortOrder);
            if (result !== 0) return result;
            return Base.strCompare(a.title, b.title);
        });
    }

    static getListFilterItemSortColumn(listItemFilter: IListFilterItem): string {
        return listItemFilter && listItemFilter.sortColumn ? listItemFilter.sortColumn : "";
    };

    static getListFilterItemSortOrderIsAsc(listItemFilter: IListFilterItem): boolean {
        return listItemFilter && !!listItemFilter.sortOrderIsAsc;
    };

    static getFilterProps<T>(listItemFilter: IListFilterItem, defaultSortColumn: string, defaultSortOrderIsAsc: boolean, getStateFilterPropsFromGeneralFilter: (generalFilter: any) => T): T & { sortColumn: string, sortOrderIsAsc: boolean } {
        let sortColumn = defaultSortColumn;
        let sortOrderIsAsc = defaultSortOrderIsAsc;
        const filterSortColumn = ListFilterItem.getListFilterItemSortColumn(listItemFilter);
        if (filterSortColumn) {
            sortColumn = filterSortColumn;
            sortOrderIsAsc = ListFilterItem.getListFilterItemSortOrderIsAsc(listItemFilter);
        }
        return {
            ...getStateFilterPropsFromGeneralFilter(listItemFilter.generalFilter),
            sortColumn,
            sortOrderIsAsc
        };
    };

    static getListFilterItems(companySavedFilters: ISavedListFilter[], userSavedFilters: ISavedListFilter[]): IListFilterItem[] {
        const result: IListFilterItem[] = [];
        const companyFilters = companySavedFilters ?? [];
        for (const companyFilter of companyFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(companyFilter, true));
        }
        const userFilters = userSavedFilters ?? [];
        for (const userFilter of userFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(userFilter, false));
        }
        ListFilterItem.sortListFilterItems(result);
        return result;
    };
}